import React from "react";
import PropTypes from "prop-types";
import {
  EmployeesAndHQWrapper,
  Header,
  Content,
  Employees,
  EmployeesCount,
  Headquarters,
  HeadquartersAddress,
  MapLink,
} from "./styles/employees-hq-styles";

const EmployeesAndHQ = ({ city, employeesCount, postalAddress }) => {
  const noData = "No data";

  return (
    <EmployeesAndHQWrapper>
      <Header>
        <Employees>Employees</Employees>
        <Headquarters>Headquarters</Headquarters>
      </Header>
      <Content>
        <EmployeesCount employeesCount={employeesCount}>
          {employeesCount || noData}
        </EmployeesCount>
        <HeadquartersAddress>
          {city || noData}
          {postalAddress && (
            <MapLink
              href={`https://www.google.com/maps/place/${postalAddress}/`}
              title="Map"
              target="_blank"
            >
              view on a map
            </MapLink>
          )}
        </HeadquartersAddress>
      </Content>
    </EmployeesAndHQWrapper>
  );
};

EmployeesAndHQ.propTypes = {
  city: PropTypes.string,
  employeesCount: PropTypes.number,
  postalAddress: PropTypes.string,
};

EmployeesAndHQ.defaultProps = {
  city: PropTypes.isNull,
  employeesCount: PropTypes.isNull,
  postalAddress: PropTypes.isNull,
};

export default React.memo(EmployeesAndHQ);
